import { Component, OnInit, Input } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'lum-rfq-other-details-form',
  templateUrl: './rfq-other-details-form.component.html',
  styleUrls: ['./rfq-other-details-form.component.scss'],
})
export class RfqOtherDetailsComponent implements OnInit {
  @Input()
  form :UntypedFormGroup;

  constructor(private fb :UntypedFormBuilder) {}

  ngOnInit() :void {
    this.initDefaults();
  }

  addField() :void {
    const fields = this.form.get('custom_fields') as UntypedFormArray;
    const fieldFc :any = this.fb.group({
      l: [''],
      v: [''],
    });
    fields.push(fieldFc);
  }

  removeField(idx :number) :void {
    const links = this.form.get('custom_fields') as UntypedFormArray;
    links.removeAt(idx);
  }

  private initDefaults() :void {
    this.addField();
  }

  get customFieldsControl() :UntypedFormArray {
    return this.form.get('custom_fields') as UntypedFormArray;
  }
}
